import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ message = 'Generating Documentation...', description = 'Audit-AI is analyzing your inputs and crafting detailed documentation. This may take a few moments.' }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: 3,
      gap: 2,
      minHeight: 300,
      backgroundColor: 'background.paper',
    }}
  >
    <CircularProgress
      size={60}
      thickness={4}
      sx={{
        color: 'primary.main',
        '& .MuiCircularProgress-circle': {
          strokeLinecap: 'round',
        },
        animation: 'rotate 1.5s linear infinite',
        '@keyframes rotate': {
          '0%': {
            transform: 'rotate(0deg)',
          },
          '100%': {
            transform: 'rotate(360deg)',
          },
        },
      }}
    />
    <Typography
      variant="h6"
      sx={{
        color: 'text.secondary',
        fontWeight: 500,
        textAlign: 'center',
        animation: 'pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite',
        '@keyframes pulse': {
          '0%, 100%': {
            opacity: 1,
          },
          '50%': {
            opacity: 0.7,
          },
        },
      }}
    >
      {message}
    </Typography>
    <Typography
      variant="body2"
      color="text.secondary"
      sx={{
        textAlign: 'center',
        maxWidth: 400,
        opacity: 0.8
      }}
    >
      {description}
    </Typography>
  </Box>
);

export default LoadingSpinner; 